import classNames from "classnames";
import { CheckableTag } from "@/shared/Components";
import { PlusIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  onClick: () => void;
};

export const Bookmark: FC<Props> = ({ title, onClick }) => {
  return (
    <CheckableTag
      onClick={onClick}
      className={classNames(styles.bookmark, styles.appearance, styles.open)}
      checked={false}
    >
      <div className={styles["bookmark-inner"]}>
        <PlusIcon />
        {title}
      </div>
    </CheckableTag>
  );
};
